import React, { Component } from 'react'
import FixedView from '../FixedView'
import Collapsible from 'react-collapsible'
import { checkTranslation, translate } from '../../utils/useful'
import IntractionActionsList from '../IntractionActionsList'

export default class NotebookFrame extends Component {
    state = {
        collapses: false,
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses = this.state.collapses == null ? false : !this.state.collapses
        this.setState({ collapses })
    }

    componentDidUpdate() {
        // console.log('sdfcgvnjkmnbgvcfdxcgvb', this.props.list)
    }

    changeFrame = (item) => {
        // this.props.functionsHandler(null, 'changePage', [(item.key ?? item._id)])
        this.framesOptionsList.hideView()
    }

    render() {
        let colors = this.props.colors
        let { list } = this.props
        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className={'flexcc pld-3 prd-4 py-1 br-5 ' + (colors?.iconInvert ? "dark-blur-bg" : 'light-blur-bg')}>
                        <div className='flexcc mrd-1'>
                            <img className={colors?.iconInvert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: colors.textColor }}>{checkTranslation(this.props.currentFrame?.name) ?? translate('Frames')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={this.props.language == 'fa' ? 170 : -9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3  ' >
                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            <div className="mt-0">
                                <div className=" mb-2">
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Pin Frames", icon: "/assets/icons/applets/database/pin-purple.svg" }} />
                                </div>
                                <div className="w-100 py-2 bb-gray">
                                    <button className="flexcb w-100 p-2 hover-gray br-5" onClick={() => this.changeCollapse()}>
                                        <div className="flexc">
                                            <p className="font-size-12 weight-500 main-c3 " style={{}}>{translate('Collections')}</p>
                                        </div>
                                        <div className='flexc'>
                                            <div className="mx-1" onClick={(e) => { e.stopPropagation(); this.props.addNewForm() }}>
                                                <div className='br-20' style={{ background: '#ddd' }}>
                                                    <img className={"transition flexcc "} width={18} src='/assets/icons/plus.svg' />
                                                </div>
                                            </div>

                                            <div className="">
                                                <img className={"transition flexcc " + (this.state.collapses == true ? "" : "rotate-90-rev")} width={18} src='/assets/icons/arrow-down-gray.svg' />
                                            </div>
                                        </div>
                                    </button>


                                    <Collapsible open={this.state.collapses}>
                                        <div className='my-1'>
                                            {Array.isArray(list) && list.map((item, index) => {
                                                return (
                                                    <div className='w-100 my-1' key={index}>
                                                        <button onClick={() => this.changeFrame(item)} className='flexcb w-100 p-2 hover-gray br-5 transition-all'>
                                                            <div className='mld-3'>
                                                                <p className='font-size-12 main-c3 '>{checkTranslation(item.title ?? item.name)}</p>
                                                            </div>
                                                            {item._id && this.props.currentFrame && this.props.currentFrame._id && item._id == this.props.currentFrame._id && (
                                                                <div className="flexcc">
                                                                    <img width={18} src="/assets/icons/check-purple.svg" />
                                                                </div>
                                                            )}
                                                        </button>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Collapsible>
                                </div>
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Pages", icon: "/assets/icons/applets/database/pages-purple.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.User Perspective", icon: "/assets/icons/applets/database/user.svg" }} />
                            </div>
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}
